<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="`transaction/invoice-v2/${inputs.id}/reject-payment-received`"
      >
        <div class="form-group row align-items-center">
          <label for="inputs_note" class="col-sm-3 mb-0">
            Note
          </label>
          <app-input
            id="inputs_note"
            class="col-sm-9"
			      v-model="inputs.note"
            type="textarea"
            placeholder="Note"
            required
          />
        </div>
        
        <div class="form-group row align-items-center">
          <div class="col-md-12">
            <br>
            <br>
          </div>
        </div>
        <div class="form-group row align-items-center">
          <div class="col-md-12">
            <br>
            <br>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { InvoiceHistoryApproveFormMixin } from "./ApproveFormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import { UserMixin } from "../../Auth/Mixins/UserMixin";

export default {
  name: "InvoiceHistoryRejectForm",
  mixins: [InvoiceHistoryApproveFormMixin,ModalMixin, UserMixin],
  props: {
    tableId: String,
    formId: String,
    confirmInvoiceId: {
        type: Number,
    },
    value: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      preloader: false,
      inputs: {
		invoice_id: this.confirmInvoiceId,
        note: "",
      },
      modalId: this.formId,
      modalTitle: "Reject Invoice",
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = 'Reject Invoice';
      this.preloader = true;
    }
  },
  methods: {
   
    submit() {
      this.save(this.inputs);
    },
    beforeSubmit() {
        this.preloader = true;
    },
    afterSuccess(res) {
        this.$toastr.s(res.data.data);
        this.$hub.$emit("reload-" + this.tableId);
        this.preloader = false;
    },
    afterError(res) {
        if (res === undefined) {
            return;
        } else if (res.data === undefined) {
            return;
        } else if (res.data.message === undefined) {
            return;
        } else {
            this.$toastr.e(res.data.message);
        }
    },
    afterSuccessFromGetEditData(response) {
        this.inputs = response.data;
       
        this.preloader = false;
    },
   
  },
};
</script>
